const warnedNames = new Set();
/**
 * @internal
 */ export function warnDeprecatedGetter(name) {
    if (warnedNames.has(name)) return;
    warnedNames.add(name);
    console.warn(`Using '${name}' is deprecated and will be removed in the near future. Please refactor to use 'get${name[0].toLocaleUpperCase()}${name.slice(1)}' instead.`);
}
